import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import pdfile from '@/api/pdf'
import { usePdftStore } from '@/store/pdf'

export const downloadPDF = (page,router) => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    html2canvas((page), {
        useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
    }).then(function(canvas) {
        canvas2PDF(canvas,router);
    });

}

// 不导出文件，上传服务器
const canvas2PDF = (canvas,router) => {
    var contentWidth = canvas.width
    var contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
    var pageHeight = contentWidth / 592.28 * 841.89
        // 未生成pdf的html页面高度
    var leftHeight = contentHeight
        // pdf页面偏移
    var position = 0
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28
    var imgHeight = 592.28 / contentWidth * contentHeight
    var pageData = canvas.toDataURL('image/jpeg', 1.0)

    // eslint-disable-next-line
    var pdf = new jsPDF('p', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
        while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
                // 避免添加空白页
            if (leftHeight > 0) {
                pdf.addPage()
            }
        }
    }
    const PdftStore = usePdftStore();
    const orgName = PdftStore.fromData.orgInfo?.orgName || 'Unknown Organization';
    const cycle = PdftStore.fromData.questionnaireInfo?.cycle || 'Unknown Cycle';
    const fileName = `${orgName} ${cycle} 碳中和进程评级报告.pdf`;
    // pdf.save(fileName)

    // var pdfFile = pdf.output('datauristring') //获取base64Pdf
    // let file = dataURLtoBlob(pdfFile)

    // 设置文件名属性
    const file = new File([pdf.output('blob')], fileName, { type: 'application/pdf' });
    
    PdftStore.postFile(file,router)
};

// 将base64转成blob 为了后续能上传
const dataURLtoBlob = (dataurl) => {
    var arr = dataurl.split(',')
        //注意base64的最后面中括号和引号是不转译的
    var _arr = arr[1].substring(0, arr[1].length - 2)
    var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], {
        type: mime
    })
};

// 直接导出文件，不上传
export const downloadPDF1 = (page) => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    html2canvas((page), {
        useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
    }).then(function(canvas) {
        canvas2PDF1(canvas);
    });

}

// 直接导出文件，不上传
const canvas2PDF1 = (canvas) => {
    var contentWidth = canvas.width
    var contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
    var pageHeight = contentWidth / 592.28 * 841.89
        // 未生成pdf的html页面高度
    var leftHeight = contentHeight
        // pdf页面偏移
    var position = 0
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
    var imgWidth = 595.28
    var imgHeight = 592.28 / contentWidth * contentHeight
    var pageData = canvas.toDataURL('image/jpeg', 1.0)

    // eslint-disable-next-line
    var pdf = new jsPDF('p', 'pt', 'a4')
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
        while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            addWatermark(pdf, 'DRAFT', pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
            leftHeight -= pageHeight
            position -= 841.89
                // 避免添加空白页
            if (leftHeight > 0) {
                pdf.addPage()
            }
        }
    }

    const PdftStore = usePdftStore();
    const orgName = PdftStore.fromData.orgInfo?.orgName || 'Unknown Organization';
    const cycle = PdftStore.fromData.questionnaireInfo?.cycle || 'Unknown Cycle';
    const fileName = `${orgName} ${cycle} 碳中和进程评级报告.pdf`;
    pdf.save(fileName)
    PdftStore.spinning = false
};


// 添加水印，自定义旋转文本功能
const addWatermark = (pdf, text, pageWidth, pageHeight) => {

    // 计算水印的坐标，放在页面正中央
    const x = pageWidth / 1.7;
    const y = pageHeight / 1.7;

    // 设置透明度和颜色
    pdf.setGState(new pdf.GState({opacity: 0.4}));
    pdf.setFontSize(60); // 设置更大的字体
    pdf.setFont("helvetica", "bold"); // 设置粗体字体
    pdf.setTextColor(200, 200, 200); // 设置灰色文本

    // 平移到中心位置，旋转，再绘制文本，最后恢复状态
    pdf.saveGraphicsState();
    pdf.text(text, x, y, { align: 'center', baseline: 'middle', angle: 45 });
    pdf.restoreGraphicsState();
};